"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _awsAmplify = require("aws-amplify");

var _awsAppsyncAuthLink = require("aws-appsync-auth-link");

var _awsAppsyncSubscriptionLink = require("aws-appsync-subscription-link");

var _awsAppsync = require("aws-appsync");

var _client = require("@apollo/client");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = function _default(_ref) {
  var cognitoUser = _ref.cognitoUser,
      appSyncConfig = _ref.appSyncConfig;
  var url = appSyncConfig.aws_appsync_graphqlEndpoint;
  var region = appSyncConfig.aws_appsync_region;
  var iamAuth = {
    type: _awsAppsync.AUTH_TYPE.AWS_IAM,
    credentials: function credentials() {
      return _awsAmplify.Auth.currentCredentials();
    }
  };
  var cognitoAuth = {
    type: _awsAppsync.AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: function () {
      var _jwtToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _awsAmplify.Auth.currentSession();

              case 2:
                return _context.abrupt("return", _context.sent.getIdToken().getJwtToken());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function jwtToken() {
        return _jwtToken.apply(this, arguments);
      }

      return jwtToken;
    }()
  };
  var httpLink = (0, _client.createHttpLink)({
    uri: url
  });

  var iamLink = _client.ApolloLink.from([(0, _awsAppsyncAuthLink.createAuthLink)({
    url: url,
    region: region,
    auth: iamAuth
  }), (0, _awsAppsyncSubscriptionLink.createSubscriptionHandshakeLink)({
    url: url,
    region: region,
    auth: iamAuth
  })]);

  var cache = new _client.InMemoryCache();

  var cognitoLink = _client.ApolloLink.from([(0, _awsAppsyncAuthLink.createAuthLink)({
    url: url,
    region: region,
    auth: cognitoAuth
  }), (0, _awsAppsyncSubscriptionLink.createSubscriptionHandshakeLink)({
    url: url,
    region: region,
    auth: cognitoAuth
  })]);

  var iamClient = new _client.ApolloClient({
    link: iamLink,
    cache: cache
  });
  var cognitoClient = new _client.ApolloClient({
    link: cognitoLink,
    cache: cache
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      appSyncClient = _useState2[0],
      setAppSyncClient = _useState2[1];

  (0, _react.useEffect)(function () {
    setAppSyncClient(cognitoUser === undefined ? null : !!cognitoUser ? cognitoClient : iamClient);
    return function () {
      return setAppSyncClient(null);
    };
  }, [JSON.stringify(cognitoUser)]);
  return appSyncClient;
};

exports["default"] = _default;